import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
import esCommon from './locales/es/common.json';
import esSettings from './locales/es/settings.json';
import esBilling from './locales/es/billing.json';
import esCustomerTabs from './locales/es/customerTabs.json';
import enCommon from './locales/en/common.json';
import enSettings from './locales/en/settings.json';
import enBilling from './locales/en/billing.json';
import enCustomerTabs from './locales/en/customerTabs.json';

const resources = {
  es: {
    common: esCommon,
    settings: esSettings,
    billing: esBilling,
    customerTabs: esCustomerTabs,
  },
  en: {
    common: enCommon,
    settings: enSettings,
    billing: enBilling,
    customerTabs: enCustomerTabs,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es',
    fallbackLng: 'es',
    defaultNS: 'common',
    ns: ['common', 'settings', 'billing', 'customerTabs'],

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: false, // Avoid suspense for SSR compatibility
    },
  });

// Custom language detection from userPreferences localStorage
// Wrapped in try-catch to handle SSR and initialization errors
try {
  if (typeof window !== 'undefined' && window.localStorage) {
    const userPrefs = localStorage.getItem('userPreferences');
    if (userPrefs) {
      // Validate JSON format before parsing
      if (!userPrefs.startsWith('{')) {
        localStorage.removeItem('userPreferences');
      } else {
        const prefs = JSON.parse(userPrefs);
        if (prefs.language && ['es', 'en'].includes(prefs.language)) {
          i18n.changeLanguage(prefs.language);
        }
      }
    }
  }
} catch (e) {
  // Clear invalid preferences on parse error
  try {
    localStorage.removeItem('userPreferences');
  } catch (removeError) {
    // Ignore removal errors
  }
}

export default i18n;
